import React from "react";
import { Status } from "./styles";

const StatusDisplay = ({ status }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case "FALHA":
        return "Red";
      case "PENDENTE":
        return "orange";
      case "SUCESSO":
        return "#009933";
      case "ESTORNADO":
        return "#9333EA"; // Purple color for reversed transactions
      default:
        return "black";
    }
  };

  return <Status status={getStatusColor(status)}> {status} </Status>;
};

export default StatusDisplay;
